module.exports = __webpack_public_path__ + "static/media/client-8.0518f63d.jpg";